import { render, staticRenderFns } from "./CampaignItemSetupBehavior.vue?vue&type=template&id=d0819ece&scoped=true&"
import script from "./CampaignItemSetupBehavior.vue?vue&type=script&lang=js&"
export * from "./CampaignItemSetupBehavior.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItemSetupBehavior.vue?vue&type=style&index=0&id=d0819ece&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0819ece",
  null
  
)

export default component.exports